const ReferralProgram = {
    selectors: {
        "parent": { selector: "#referral-modal", type: "single", scope: "document" },
        "referralModal": { selector: "#referral-modal", type: "single", scope: "document" },
        "referralMessage": { selector: "h2", type: "single", scope: "parent" },
        "referrerNameEl": { selector: "#referrer-name", type: "single", scope: "document" },
        "closeReferralBtns": { selector: ".icon-close", type: "all", scope: "parent" },
        "selfReferralModal": { selector: "#self-referral-modal", type: "single", scope: "document" },
        "errorModal": { selector: "#error-modal", type: "single", scope: "document" }
    },
  
    init: async function(customerOrdersCount) { 
        Utility.fetchEls(this.selectors, this);
        this.urlParams = new URLSearchParams(window.location.search);
        this.referralCode = this.urlParams.get('referralCode');
        this.referralModalClosed = sessionStorage.getItem('referralModalClosed');
        this.referrerName = '';
        this.validReferral = false;
        this.fingerprint = await this.getFingerPrint();

        if (this.referralCode) {
            await this.getReferralData();
            if (this.validReferral) {
                // Save referral code in session storage
                sessionStorage.setItem('referralCode', this.referralCode);
                if (customerOrdersCount == 0) {
                    this.addCartAttribute();
                }
                if (!this.referralModalClosed){
                    this.initReferralModal();
                }
            } else if (this.selfReferral) {
                this.selfReferralModal.style.display = 'flex';
                this.referralModal.style.display = 'none';
            } else if (!this.validReferral && !this.selfReferral) {
                this.errorModal.style.display = 'flex';
                this.referralModal.style.display = 'none';
            }
        }

        // Close modal
        this.closeReferralBtns.forEach((btn) => {
            btn.onclick = function () {
                btn.closest('.referral-modal').style.display = 'none';
                sessionStorage.setItem('referralModalClosed', 'true'); // Mark modal as closed
            };
        });
    },

    getFingerPrint: async function() {
        const fpPromise = FingerprintJS.load();
        // Generate the fingerprint
        const fp = await fpPromise;
        const result = await fp.get();
        const fingerprint = result.visitorId;

        return fingerprint;
    },

    getReferralData: async function() {
        try {
            const response = await fetch(`https://api.selkirk.com/functions/v1/p1/selkirksport/user/validateReferralCode?referralCode=${encodeURIComponent(this.referralCode)}&fingerprint=${this.fingerprint}`);
            if (!response.ok) {
                throw new Error(`Network response was not ok: ${response.status}`);
            }
            const data = await response.json();
            const refInfo = data?.data || {};

            if (refInfo.valid) {
                this.validReferral = true;
                this.referrerName = refInfo.firstName || '';
                this.referrerEmail = refInfo.email || '';
                this.referrerPhone = refInfo.phone || '';
            } else {
                this.validReferral = false;
                this.selfReferral = refInfo.selfReferral ? true : false;
                console.error('Referral code not valid:', data);
            }
        } catch (error) {
            this.validReferral = false; // Set flag to false in case of an error
            this.selfReferral = false;
            console.error('Error validating referral code:', error);
        }
    },

    addCartAttribute: async function() {
        try {
            const response = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    attributes: {
                        referralCode: this.referralCode,
                        referrerName: this.referrerName,
                        referrerEmail: this.referrerEmail,
                        referrerPhone: this.referrerPhone
                    },
                }),
            });
            const cart = await response.json();
        } catch (error) {
            console.error('Error updating cart:', error);
        }
    },

    initReferralModal: function() {
        const { referralModal, referrerNameEl, referralMessage } = this;
    
        referralModal.style.display = 'flex';
        if (this.referrerName) {
            referrerNameEl.textContent = this.referrerName;
        } else {
            referralMessage.textContent = 'You were referred!';
        }
    }
};